import React, { CSSProperties, FunctionComponent, useMemo } from 'react';

import { Option } from '@gojob/ui-bits/PlacesAutocomplete/useRemoteOptions';
import Skeleton from '@gojob/ui-bits/Skeleton';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';

import useTranslation from 'src/translations/useTranslation';

export type CountProps = {
  city?: Option | null;
  count?: number;
  loading?: boolean;
  className?: string;
  style?: CSSProperties;
};

const Count: FunctionComponent<CountProps> = (props) => {
  const { city, count, loading, className, style } = props;
  const { spacing } = useTheme();

  const t = useTranslation();

  const content = useMemo(() => {
    if (count) {
      const cityName = city?.nom;
      const context = cityName ? 'city' : undefined;
      return t('{count}_job_offers', { count, context, cityName });
    }
  }, [t, count, city, loading]);

  return (
    <Text data-testid="Count" inactive className={className} style={style}>
      {loading ? <Skeleton width={spacing(24)} /> : content}
    </Text>
  );
};

export default Count;
